<!--CC: card-based reviewers list for the onboarding wizard, modeled on onboarding-domains.component.html-->
<div class="flex-column gap-3 f-1-0" style="overflow: auto;">

	<!--CC: loading state-->
	<div class="flex-column align-items-center justify-content-center f-1-0" *ngIf="loadingInProcess">
		<loader></loader>
	</div>

	<ng-container *ngIf="!loadingInProcess && config">

		<!--CC: add reviewer actions and search-->
		<div class="flex-row align-items-center gap-2">
			<!--CC: taken from reviewers.component.html -> tableButtons-->
			<div class="btn-with-dropdown">
				<btn-c endIcon="far fa-plus" (action)="openAddReviewer()">
					Add Reviewer
				</btn-c>
				<app-dropdown-c [isLf]="true">
					<li (click)="openUsersSelection()">Add from my users</li>
				</app-dropdown-c>
			</div>
			<input type="text" placeholder="Search reviewers..." class="ms-auto"
				   style="width: 250px; margin-bottom: unset;"
				   [(ngModel)]="searchTerm"
				   (ngModelChange)="searchReviewers()"/>
		</div>

		<!--CC: empty state-->
		<div class="flex-column align-items-center gap-2 py-4 text-muted" *ngIf="!config.reviewers?.length">
			<i class="far fa-user-shield" style="font-size: 32px;"></i>
			<span>No reviewers yet</span>
			<span style="font-size: 0.85em;">Reviewers get notified about quarantined emails and decide what happens to them.</span>
		</div>

		<!--CC: reviewer cards-->
		<div class="flex-column gap-2" *ngIf="config.reviewers?.length">
			<ng-container *ngFor="let reviewerObj of config.reviewers">
				<div class="flex-column border rounded" *ngIf="!reviewerObj.hide">

					<!--CC: reviewer row — email, assignments, permission chips, actions-->
					<div class="flex-row align-items-center gap-3 p-3 hvr-darken-light cursor-pointer"
						 (click)="togglePermissions(reviewerObj)">
						<div class="flex-column gap-1 f-1-0" style="min-width: 0;">
							<div class="flex-row align-items-center gap-2">
								<i class="far fa-user-shield text-muted"></i>
								<span class="fw-bold text-truncate">{{reviewerObj.email}}</span>
								<span class="badge bg-primary" *ngIf="reviewerObj.is_primary"
									  tooltip="The primary reviewer receives notifications for all groups/mailboxes for which no reviewer is specified">
									Primary
								</span>
							</div>

							<!--CC: groups and mailboxes the reviewer is assigned to-->
							<div class="flex-row align-items-center gap-3 text-muted" style="font-size: 0.85em;"
								 *ngIf="reviewerObj.groupsLabel || reviewerObj.mailboxesLabel">
								<span class="flex-row align-items-center gap-1 text-truncate" *ngIf="reviewerObj.groupsLabel"
									  [tooltip]="'Assigned to groups: ' + reviewerObj.groupsLabel">
									<i class="far fa-users"></i>
									{{reviewerObj.groupsLabel}}
								</span>
								<span class="flex-row align-items-center gap-1 text-truncate" *ngIf="reviewerObj.mailboxesLabel"
									  [tooltip]="'Assigned to mailboxes: ' + reviewerObj.mailboxesLabel">
									<i class="far fa-user"></i>
									{{reviewerObj.mailboxesLabel}}
								</span>
							</div>

							<!--CC: permission chips-->
							<div class="flex-row gap-2 flex-wrap justify-content-start">
								<span class="badge" *ngFor="let permission of permissions"
									  style="font-size: 0.85em;"
									  [tooltip]="permission.description"
									  [ngClass]="reviewerObj[permission.key] ? 'bg-success' : 'bg-light text-muted border'">
									{{permission.label}}
								</span>
							</div>
						</div>

						<!--CC: action buttons. stopPropagation so they don't also expand the row-->
						<div class="flex-row align-items-center gap-2" (click)="$event.stopPropagation()">
							<btn-c class="shrunk" variant="text" endIcon="far fa-star"
								   btnTooltip="Set as primary reviewer"
								   *ngIf="!reviewerObj.is_primary"
								   (action)="setReviewerAsPrimary(reviewerObj)">
							</btn-c>
							<btn-c class="shrunk" variant="text" endIcon="far fa-users"
								   btnTooltip="Assign to groups"
								   (action)="openAssignReviewerToGroupsPopup(true, reviewerObj)">
							</btn-c>
							<btn-c class="shrunk" variant="text" endIcon="far fa-user"
								   btnTooltip="Assign to mailboxes"
								   (action)="openAssignReviewerToMailboxesPopup(true, reviewerObj)">
							</btn-c>
							<btn-c class="shrunk" variant="text" color="danger" endIcon="far fa-trash-alt"
								   btnTooltip="Remove reviewer"
								   (action)="removeReviewers([reviewerObj])">
							</btn-c>
							<btn-c class="shrunk" variant="text" endIcon="far fa-chevron-down"
								   btnTooltip="Show permissions"
								   [ngStyle]="{'transform': reviewerObj.isExpanded ? 'rotate(180deg)' : 'none'}"
								   style="transition: transform 0.2s;"
								   (action)="togglePermissions(reviewerObj)">
							</btn-c>
						</div>
					</div>

					<!--CC: expandable permissions section-->
					<div class="flex-column gap-2 p-3 border-top" style="background: #fafafa;" *ngIf="reviewerObj.isExpanded">
						<div class="flex-row align-items-center gap-3 p-3 rounded border bg-white"
							 *ngFor="let permission of permissions">
							<div class="flex-column gap-1 f-1-0">
								<b>{{permission.label}}</b>
								<span class="text-muted lh-base" style="font-size: 0.85em;">{{permission.description}}</span>
							</div>
							<toggle-switch-c [id]="permission.key + '_' + reviewerObj.email"
											 [hideText]="true"
											 [(model)]="reviewerObj[permission.key]"
											 (onChange)="updateReviewerPermission(reviewerObj, permission)"></toggle-switch-c>
						</div>
					</div>
				</div>
			</ng-container>
		</div>

		<!--CC: general reviewer settings, taken from reviewers.component.html-->
		<div class="flex-column gap-2 p-3 border rounded">
			<div class="flex-row align-items-center gap-3">
				<div class="flex-column gap-1 f-1-0">
					<b>Notify about email content being viewed</b>
					<span class="text-muted lh-base" style="font-size: 0.85em;">
						The plan admins will receive an automated notification whenever a reviewer views a user email's content
					</span>
				</div>
				<toggle-switch-c id="notify_reviewer_view_content"
								 [hideText]="true"
								 [(model)]="config.notify_reviewer_view_content"
								 (onChange)="updateNotifyReviewerViewContent()"
								 [isDisabled]="actionInProcess"></toggle-switch-c>
			</div>
		</div>
	</ng-container>

	<!--CC: add reviewer popup, modeled on onboarding-domains.component.html -> add domain popup-->
	<popup-c class="bs-enabled" *ngIf="addReviewerPopup?.show"
			 head="Add Reviewer" size="dynamic"
			 (closeCb)="addReviewerPopup.show = false;"
			 (confirmCb)="addReviewer()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add Reviewer', disabled: addReviewerPopup.applyInProcess || !addReviewerPopup.email.length}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<p style="font-size: 14px;">Please fill in the reviewer's email address</p>

			<div class="align-items-center flex-row gap-3">
				<div>Email:</div>
				<input type="text" placeholder="Reviewer email (required)"
					   style="width: 330px;" [required]="true"
					   [(ngModel)]="addReviewerPopup.email"
					   [ngStyle]="!addReviewerPopup.email && addReviewerPopup.errMsg ? {'border-color': 'red'} : {}"/>
			</div>
			<p>The reviewer will be added with the default permissions, which you can change afterwards.</p>
			<p class="text-danger" *ngIf="addReviewerPopup.errMsg">{{addReviewerPopup.errMsg}}</p>
		</div>
	</popup-c>
</div>

<users-selection-component
	*ngIf="usersSelectionPopup?.show"
	[data]="usersSelectionPopup"
	[selectedUsers]="selectedUsers"
	(addCb)="startAddFromUsersSelection($event.users)"
	(removeCb)="startRemoveFromUsersSelection($event.users)">
</users-selection-component>

<groups-popup-c
	*ngIf="assignReviewerToGroupsPopup"
	(cancelCb)="openAssignReviewerToGroupsPopup(false)"
	(doneCb)="applyReviewerToGroups($event.groups)"
	doneBtnTxt="Apply"
	[selectedGroups]="assignReviewerSelectedGroups"
	[multipleSelection]="true"
	popupTitle="Assign reviewer to groups">
</groups-popup-c>

<popup-c *ngIf="assignReviewerToMailboxesPopup?.show"
		 head="Select Mailboxes" class="overflownV"
		 subTitle="Only reviewers assigned to specific mailboxes will receive quarantine notifications for those mailboxes"
		 (closeCb)="assignReviewerToMailboxesPopup = null;"
		 (confirmCb)="applyReviewerToMailboxes();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: assignReviewerToMailboxesPopup.actionInProcess}}" size="medium">
	<div class="flxClmn vSpace3 f-1-0">
		<trustifi-table-c
			class="trustifi-table f-1-0" style="z-index: 5;"
			[list]="assignReviewerToMailboxesPopup.mailboxes"
			[headers]="[
				{text: 'Email', sortKey: 'email'},
				{text: 'Name', sortKey: 'name'},
			  ]"
			[cellsPrototype]="[
				{textKey: 'email'},
				{textKey: 'name'},
			  ]"
			(searchFunction)="searchMailbox($event)"
			[options]="{
				itemsNameSingular: 'mailbox',
				loadingTableFlag: assignReviewerToMailboxesPopup.mailboxesInProcess,
				showRadioButtons: true,
			}"
		>
		</trustifi-table-c>
		<checkbox id="only_selected_mailboxes" [(model)]="assignReviewerToMailboxesPopup.only_selected_mailboxes">
			Receive quarantine notifications only for the selected mailboxes
		</checkbox>
	</div>
</popup-c>
